import { useParams } from "react-router";
import CreateLottery from "./CreateLottery";
import { CreateCashback } from "./CreateCashback";

export const GameComponent = () => {
  const { game } = useParams();

  if (game === 'lottery') return <CreateLottery />
  else if (game === 'cashback') return <CreateCashback />
}
